import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Pagination from "../Pagination/Pagination";
import { Tooltip as ReactTooltip } from "react-tooltip";
// import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../utils/constant";
import $ from "jquery";
import { toastr } from "react-redux-toastr";

const SchedulingScan = () => {
    const [schedules, setSchedules] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [search, setSearch] = useState("");
    const [interval, setInterval] = useState("");
    const [tag, setTag] = useState("");
    const [uniqueTags, setUniqueTags] = useState([]);
    const [isModal, setModal] = useState("");
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const [formData, setFormData] = useState({
        tag: "",
        interval: "monthly",
        startsFrom: new Date().toISOString().split('T')[0],
        scanType: "nuclei",
        scanMode: "tag"
    });

    const { orgId } = useParams();
    const auth = useSelector((state) => state?.auth?.user);

    const id = useSelector(state => {
        if (orgId) {
            return orgId;
        } else {
            return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
        }
    });

    useEffect(() => {
      if(id){
        fetchSchedules();
        fetchUniqueTags();
      }
    }, [id, page, search, interval, tag, limit]);

    const fetchSchedules = async () => {
        try {
            setLoading(true);
            const session = localStorage.getItem("session");
            const queryParams = new URLSearchParams({
                page,
                limit,
                tag,
                interval
            }).toString();

            const response = await axios.get(
                `${API_URL}/scanschedule/tag/${id}/list?${queryParams}`,
                {
                    headers: { Authorization: `Bearer ${session}` }
                }
            );

            if (response.data?.data) {
                setSchedules(response.data.data);
                setTotalItems(response.data.data.length);
            }
        } catch (error) {
            // console.error removed
        } finally {
            setLoading(false);
        }
    };

    const fetchUniqueTags = async () => {
        try {
            const session = localStorage.getItem("session");
            const response = await axios.get(
                `${API_URL}/digital-inventory/${id}/tags?search=`,
                {
                    headers: { Authorization: `Bearer ${session}` }
                }
            );

            if (response.data?.data) {
                setUniqueTags(response.data.data);
            }
        } catch (error) {
            // console.error removed
        }
    };

    const handleScheduleSubmit = async () => {
        try {
            setLoading(true);
            const session = localStorage.getItem("session");
            
            // Validation checks
            if(formData.scanMode === "tag" && formData.tag === ""){
                toastr.error("Error", "Tag is required");
                return;
            }
            if(formData.interval === ""){
                toastr.error("Error", "Interval is required");
                return;
            }
            if(formData.startsFrom === ""){  
                toastr.error("Error", "Starts From is required");
                return;
            }

            const isUpdate = selectedSchedule !== null;
            
            // Create payload based on operation type
            const payload = {
                interval: formData.interval,
                startsFrom: new Date(formData.startsFrom).toISOString(),
                scanType: formData.scanMode === "full" ? "fullScan" : "tagsBasedScan",
                tags: formData.scanMode === "full" ? ["full"] : [formData.tag],
                organisationId: id
            };

            // Determine URL and method based on operation type
            const url = isUpdate 
                ? `${API_URL}/scanschedule/tag/organisation/${id}/${selectedSchedule._id}/update`
                : `${API_URL}/scanschedule/tag`;
            
            const method = isUpdate ? 'put' : 'post';

            const response = await axios[method](
                url,
                payload,
                {
                    headers: { Authorization: `Bearer ${session}` }
                }
            );

            // Show success message from API response
            if (response.data?.userMessage) {
                toastr.success("Success", response.data.userMessage);
            }

            setModal("");
            fetchSchedules();
            fetchUniqueTags();
            resetForm();
        } catch (error) {
            // Display specific API error message if available
            if (error.response?.data?.userMessage) {
                toastr.error("Error", error.response.data.userMessage);
            } else {
                toastr.error("Error", `Failed to ${selectedSchedule ? "update" : "create"} schedule. Please try again.`);
            }
        } finally {
            setLoading(false);
        }
    };

    const deleteSchedule = async (scheduleId) => {
        $.confirm({
            title: "Are you sure?",
            content: "Do you really want to delete this schedule?",
            type: "red",
            buttons: {
                ok: {
                    text: "Yes, Delete",
                    btnClass: "btn-danger",
                    keys: ["enter"],
                    action: function () {
                        deleteScheduleConfirmed(scheduleId);
                    },
                },
                cancel: function () {
                    // Cancel action
                },
            },
        });
    };

    const deleteScheduleConfirmed = async (scheduleId) => {
        try {
            setLoading(true);
            const session = localStorage.getItem("session");

            const response = await axios.delete(
                `${API_URL}/scanschedule/tag/organisation/${id}/${scheduleId}/delete`,
                {
                    headers: { Authorization: `Bearer ${session}` }
                }
            );

            toastr.success("Success", response?.data?.userMessage);

            fetchSchedules();
            fetchUniqueTags();
        } catch (error) {
            toastr.error("Error deleting schedule:", error);
            // alert("Failed to delete schedule. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSearchChange = (e) => {
        const inputValue = e.target.value;
        clearTimeout(handleSearchChange.timeoutId);
        handleSearchChange.timeoutId = setTimeout(() => {
            setSearch(inputValue);
            setPage(1);
        }, 1000);
    };

    const openCreateModal = () => {
        resetForm();
        setSelectedSchedule(null);
        setModal("Form Wizard modal");
    };

    const openEditModal = (schedule) => {
        setSelectedSchedule(schedule);
        setFormData({
            tag: schedule.tags?.[0] || "",
            interval: schedule.interval,
            startsFrom: schedule.nextScanAt ? new Date(schedule.nextScanAt).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
            scanType: schedule.scanType || "nuclei",
            scanMode: schedule.scanType === "fullScan" ? "full" : "tag"
        });
        setModal("Form Wizard modal");
    };

    const resetForm = () => {
        setFormData({
            tag: "",
            interval: "monthly",
            startsFrom: new Date().toISOString().split('T')[0],
            scanType: "nuclei",
            scanMode: "tag"
        });
        setSelectedSchedule(null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleScheduleSubmit();
    };

    return (
        <>
            <div className="container-fluid">
                <AccessPage />
                                        <ReactTooltip className="reactTooltipClass" />
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1 className="welcome-text">Scan Schedule Management</h1>
                            <nav aria-label="breadcrumb" className="mt-1">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/" className="welcome-textSmall">
                                            Home
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/consolidated-assets" className="welcome-textSmall">
                                            Consolidated Assets
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page" style={{ color: "white" }}>
                                        Scan Schedules
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
                            <label className="custom-file-label-upload"
                            style={{height:"fit-content"}}
                            onClick={openCreateModal}>
                                Create Schedule
                            </label>
                        </div>
                    </div>
                </div>

                {/* {loading && <div className="card border-success"><ScanMessage /></div>} */}

                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12">
                        <div className="card card_tableBox">
                            <div className="header">
                                <div className="body">
                                    <div className="row">
                                        <div className="col-sm-3 mb-2">
                                            <select
                                                className="custom-select custom-select-sm form-control form-control-sm"
                                                value={interval}
                                                onChange={(e) => {
                                                    setInterval(e.target.value);
                                                    setPage(1);
                                                }}
                                            >
                                                <option value="">All Intervals</option>
                                                <option value="daily">Daily</option>
                                                <option value="weekly">Weekly</option>
                                                <option value="monthly">Monthly</option>
                                                <option value="quarterly">Quarterly</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-3 mb-2">
                                            <select
                                                className="custom-select custom-select-sm form-control form-control-sm"
                                                value={tag}
                                                onChange={(e) => {
                                                    setTag(e.target.value);
                                                    setPage(1);
                                                }}
                                            >
                                                <option value="">All Tags</option>
                                                {uniqueTags.map((tag, index) => (
                                                    <option key={index} value={tag}>
                                                        {tag}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-custom spacing5 mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Scan Type</th>
                                                    <th>Interval</th>
                                                    <th>Tag</th>
                                                    <th>Created At</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {schedules.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            {loading ? "Loading..." : "No schedules found"}
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    schedules.map((schedule, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {schedule.scanType || "N/A"}
                                                            </td>
                                                            <td>
                                                                <span className="badge badge-info">{schedule.interval || "N/A"}</span>
                                                            </td>
                                                            <td>
                                                                <span className="badge badge-info">{schedule.tags || "N/A"}</span>
                                                            </td>
                                                            <td>
                                                                {schedule.createdAt
                                                                    ? new Date(schedule.createdAt).toLocaleDateString()
                                                                    : "N/A"}
                                                            </td>
                                                            
                                                            <td>
                                                                <Link
                                                                    to="#"
                                                                    className="mr-1"
                                                                    onClick={() => openEditModal(schedule)}
                                                                >
                                                                    Edit
                                                                </Link>
                                                                <Link to="#"
                                                                    className="text-danger"
                                                                    onClick={() => deleteSchedule(schedule?._id)}
                                                                >
                                                                    Delete
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between align-content-center">
                                        <div className="dataTables_paginate">
                                            {totalItems > 0 && (
                                                <Pagination
                                                    className="pagination-bar"
                                                    currentPage={page}
                                                    totalCount={totalItems}
                                                    pageSize={limit}
                                                    onPageChange={(page) => setPage(page)}
                                                />
                                            )}
                                        </div>
                                        {totalItems > 10 && (
                                            <select
                                                value={limit}
                                                onChange={(e) => setLimit(parseInt(e.target.value))}
                                                className="form-control limitSelectBox"
                                            >
                                                <option value={10}>10 per page</option>
                                                <option value={25}>25 per page</option>
                                                <option value={50}>50 per page</option>
                                                <option value={100}>100 per page</option>
                                            </select>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal for creating/editing schedules */}
                <div className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""}`}>
                    <div className="modal-dialog" id="clientModal">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    {selectedSchedule ? "Edit Schedule" : "Create Schedule"}
                                </h5>
                                <button
                                    type="button"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setModal("")}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label>Scan Type</label>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="scanMode"
                                                id="tagScan"
                                                value="tag"
                                                checked={formData.scanMode === "tag"}
                                                onChange={(e) => setFormData({...formData, scanMode: e.target.value, tag: ""})}
                                            />
                                            <label className="form-check-label" htmlFor="tagScan">
                                                Tag-based Scan
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="scanMode"
                                                id="fullScan"
                                                value="full"
                                                checked={formData.scanMode === "full"}
                                                onChange={(e) => setFormData({...formData, scanMode: e.target.value, tag: "full"})}
                                            />
                                            <label className="form-check-label" htmlFor="fullScan">
                                                Full Scan
                                            </label>
                                        </div>
                                    </div>
                                    {formData.scanMode === "tag" && (
                                        <div className="form-group">
                                            <label>Tag</label>
                                            <select
                                                className="form-control"
                                                name="tag"
                                                value={formData.tag}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Select a tag</option>
                                                {uniqueTags.map((tag, index) => (
                                                    <option key={index} value={tag}>
                                                        {tag}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="form-text text-muted">
                                                Select a tag from the existing tags
                                            </small>
                                        </div>
                                    )}
                                    <div className="form-group">
                                        <label>Interval</label>
                                        <select
                                            className="form-control"
                                            name="interval"
                                            value={formData.interval}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="daily">Daily</option>
                                            <option value="weekly">Weekly</option>
                                            <option value="monthly">Monthly</option>
                                            <option value="quarterly">Quarterly</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Next Scan Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="startsFrom"
                                            value={formData.startsFrom}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-default"
                                            onClick={() => setModal("")}
                                        >
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? "Processing..." : selectedSchedule ? "Update" : "Create"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SchedulingScan;
